// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"988eccec","442":"12824b8a"}[chunkId] + ".chunk.css";
};